export const SLIDER_DEFAULT_VALUE = 5.5